import {MouseEvent, useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';

import {TypedDispatch} from 'shared/model/types';

import {fetchMe} from './thunks/fetchMe';

interface IUseActiveToggleParams {
    initial: boolean,
    update: (_next: boolean) => Promise<{data?: unknown, error?: unknown}>,
    activatedText: string,
    deactivatedText: string,
    canActivate: boolean,
    onLimitExceeded: () => void,
}

const useActiveToggle = ({
    initial,
    update,
    activatedText,
    deactivatedText,
    canActivate,
    onLimitExceeded,
}: IUseActiveToggleParams) => {
    const [isActive, setIsActive] = useState(initial);
    const dispatch = useDispatch<TypedDispatch>();

    const toggle = useCallback(async(event: MouseEvent) => {
        event.stopPropagation();
        const next = !isActive;
        if (next && !canActivate) {
            onLimitExceeded();
            return;
        }
        setIsActive(next);
        const result = await update(next);
        if ('error' in result) {
            setIsActive(!next);
            return;
        }
        toast.info(next ? activatedText : deactivatedText);
        dispatch(fetchMe());
    }, [isActive, canActivate, onLimitExceeded, update, activatedText, deactivatedText, dispatch]);

    return {isActive, toggle};
};

export default useActiveToggle;
